import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import AdminLayout from "./layouts/admin";
import NotFound from "./layouts/components/NotFound";
import DefaultLayout from "./layouts/default";
import Login from "./pages/login/Login";
import SamplingDone from "./pages/sampler/SamplingDone";
import {checkAuth, getVendorType} from "./services/auth";
import { getDashboard } from './utils/utils';
import Transactions from "./pages/transactions/Transactions";
import Profile from "./pages/profile/Profile";
import Orders from "./pages/orders/Orders";
import {isBrowser} from "react-device-detect";
import OrdersMobile from "./pages/orders/OrdersMobile";
import TransactionsMobile from "./pages/transactions/TransactionsMobile";
const renderAdminPanel = (hist) => {
  const vendor_type = getVendorType();
  if (checkAuth()) {
    return (
      <AdminLayout history={hist}>
        <Switch>
          <Route
            path="/panel/dashboard"
            exact
            render={() => getDashboard(vendor_type, hist)}
          />
          <Route
            path="/panel/financial-report"
            exact
            render={() => isBrowser ? <Transactions {...hist} /> : <TransactionsMobile {...hist} />}
          />
          <Route
            path="/panel/order-report"
            exact
            render={() => isBrowser ? <Orders {...hist} /> : <OrdersMobile {...hist} />}
          />
          {!isBrowser && (
            <Route
              path="/panel/profile"
              exact
              render={() => <Profile {...hist} />}
            />
          )}
          <Route render={() => <NotFound />} exact path="/*" />
        </Switch>
      </AdminLayout>
    );
  } else {
    return <Redirect to="/login" />;
  }
};
const renderSimplePanel = (hist) => {
  return (
    <DefaultLayout history={hist}>
      <Switch>
        <Route
          path="/sampling-done"
          exact
          render={() => <SamplingDone {...hist}/>}
        />
        <Route
          path="/login"
          exact
          render={() => checkAuth() ? <Redirect to="/panel/dashboard" /> : <Login {...hist}/>}
        />
        <Route
          path="/"
          exact
          render={() => {
            return checkAuth() ? <Redirect to="/panel/dashboard" /> : <Redirect to="/login" />;
          }}
        />
        <Route render={() => <NotFound />} exact path="/*" />
      </Switch>
    </DefaultLayout>
  );
};

export {
  renderAdminPanel,
  renderSimplePanel,
};
